import axios from 'axios';
import Cookies from 'js-cookie';

class ApiService {
  
 constructor(endpoint, headers = {}, method = '', body = null) {
  this.endpoint = endpoint;
  this.headers = {
    'Content-Type': 'application/json',  // Ensure 'Content-Type' is always set
    ...headers,                          // Merge custom headers
  };
  this.method = method;
  this.body = body;

  // Default token
  let authToken = Cookies.get('tokenRes');

  // If endpoint contains 'super_admin' but not 'super_admin/login'
  if (endpoint.includes('super_admin') && !endpoint.includes('super_admin/login')) {
    authToken = Cookies.get('SuperAdminToken');
  }

  // Set Authorization header if token exists
  if (authToken) {
    this.headers['Authorization'] = `Bearer ${authToken}`;
  }
}


  async makeCall(navigate) {
    try {
      const options = {
        url: this.endpoint,
        method: this.method,
        headers: this.headers,
        data: this.body,
      };

      const response = await axios(options);

      if (response.status >= 200 && response.status < 300) {
        return response.data;
      } 
      
      else {
        throw new Error(`API call failed with status code ${response.status}`);
      }
    } catch (error) {
      if (error.response && error.response.data) {
        const statusCode = error.response.status; // Get the status code

        if(statusCode === 403){
          if(navigate){
          navigate("/AccessDenied");
          }
          throw error.response.data;  // Instead of just error.message
        }
        else if(statusCode === 500){
          if(navigate){
          navigate("/SomethingWentWrong");
          }
          throw error.response.data;  // Instead of just error.message
        }

        else if(statusCode === 404){
          if(navigate){
          navigate("/PageDoesNotExist");
          }
          throw error.response.data;  // Instead of just error.message
        }
        else if(statusCode === 422){
          if(navigate){
          navigate("/UnprocessableEntity");
          }
          throw error.response.data;  // Instead of just error.message
        }
        else if(statusCode === 400){
          if(navigate){
          navigate("/BadRequest");
          }
          throw error.response.data;  // Instead of just error.message
        }
        else if(statusCode === 401){
          if(navigate){
          navigate("/Unauthorized");
          }
          throw error.response.data;  // Instead of just error.message
        }
        // Pass the error message from the response back to the caller
        throw error.response.data;  // Instead of just error.message
      } else if (error.request) {
        throw new Error('API call failed: No response received');
      } else {
        throw new Error(`API call failed: ${error.message}`);
      }
    }
  }
}

export default ApiService;
